import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import {
  loadCirculation,
  loadCirculations
} from "../circulation/state/actions/circulation.api.actions";
import { LogClass, Logger } from "../logger";
import { loadStepsForCirculation } from "../step/state/actions/step.api.actions";
import * as AppAction from "./app.actions";
import * as AppState from "./app.state";

@LogClass({ source: "AppEffects" })
@Injectable()
export class AppEffects {
  constructor(private actions$: Actions, private store: Store) {}

  logger: Logger;
  routerNavigatedLoadCirculation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppAction.RouterNavigated),
      switchMap(() =>
        this.store.select(AppState.selectCirculationId).pipe(
          this.logger.observableOperator("CirculationId"),
          switchMap((id) =>
            of(id ? loadCirculation({ id }) : loadCirculations())
          )
        )
      )
    );
  });

  routerNavigatedLoadSteps$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppAction.RouterNavigated),
      switchMap(() =>
        this.store.select(AppState.selectCirculationId).pipe(
          this.logger.observableOperator("CirculationId"),
          filter((id) => !!id),
          switchMap((id) => of(loadStepsForCirculation({ id }))) //I do not think that this is a hack. Fixes ngrx/avoid-mapping-selectors
        )
      )
    );
  });
}
